import { Card, UploadFile, message } from 'antd'
import { AdminCModal, CButton } from 'app/components/Common'
import React, { useState } from 'react'
import { COLORS } from 'app/constants'
import EventCreateImage from './EventCreateImage'
import EventInput from 'app/adminpages/AdminEvents/EventInput'
import { useEvents } from 'app/hooks/Events/event'
import { awsUploadImage } from 'utils/awsImageStorage'
import { View } from 'styles/reactnative'
import { anyTruthy } from 'utils/ExpensiveFunction'
import { RichTextCreateEditor } from 'app/components/'

const EventCreateModal = ({ showModal, setShowModal }) => {
	const [messageApi, contextHolder] = message.useMessage()

	const { createEvent } = useEvents()
	const [images, setImages] = useState<UploadFile[]>([])
	const [title, setTitle] = useState('')
	const [content, setContent] = useState('')

	const AddForm = async () => {
		if (anyTruthy(title, content)) {
			let resultImages: any = []
			if (images?.length) {
				resultImages = await Promise.all(
					images.map(async (file, index) => {
						const resultImage = await awsUploadImage(
							{ file: file?.originFileObj },
							index + 1,
							'profile',
							'user'
						)
						return resultImage
					})
				)
			}

			await createEvent({
				title: title,
				content: content,
				images: resultImages.filter(Boolean),
			})
			setTitle('')
			setContent('')
			setImages([])
			setShowModal(!showModal)
		} else {
			messageApi.info('제목이나 내용을 추가해야 함')
		}
	}
	return (
		<AdminCModal width={1000} show={showModal} setShow={setShowModal}>
			{contextHolder}
			<Card title="이벤트 등록" style={{ minHeight: 600 }}>
				<EventInput
					value={title}
					setValue={setTitle}
					name={'제목'}
					placeholder={'제목'}
				/>
				<RichTextCreateEditor
					content={content}
					setContent={setContent}
				/>
				{/* <EventTextArea
					value={content}
					setValue={setContent}
					name={'내용'}
					placeholder={'내용'}
				/> */}

				<EventCreateImage images={images} setImages={setImages} />

				<View style={{ marginTop: 20 }}>
					<CButton
						title={'저장'}
						onClick={AddForm}
						style={{
							background: COLORS.primary,
							width: 200,
							height: 30,
							color: COLORS.white,
						}}
					/>
				</View>
			</Card>
		</AdminCModal>
	)
}

export default EventCreateModal
